import BasicSetting, { PATH as BASIC_SETTING } from './BasicSetting';

export default { BasicSetting };
export const PATH = { BASIC_SETTING };
